import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlanForm from '../containers/PlanFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlanEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlanEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('plans_route_edit')} />
          <PlanForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlanEditScreen;

Logger.log('silly', `PlanEditScreen loaded.`);
